module.exports = __webpack_public_path__ + "img/web.0f72e0bf.jpg";